import clsx from 'clsx'

const GRID_OPTIONS = [3, 4]

// 3 columns up to the xxl breakpoint (1828px), 4 on larger screens
export function getDefaultGridCols() {
  if (typeof window === 'undefined') return 3
  return window.matchMedia('(min-width: 1828px)').matches ? 4 : 3
}

export function GridLayoutToggle({ gridCols, setGridCols }) {
  return (
    <div className="hidden lg:flex items-center gap-x-0.5 text-xs" role="radiogroup" aria-label="Product Grid Columns">
      <span className="text-type-black-primary whitespace-nowrap">Product Grid:</span>
      {GRID_OPTIONS.map((cols) => {
        const isActive = gridCols === cols
        return (
          <button
            key={cols}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={`${cols} columns`}
            onClick={() => setGridCols(cols)}
            className={clsx(
              'text-xs link-fade',
              isActive ? 'underline text-type-black-primary' : 'text-type-black-secondary'
            )}
          >
            {cols}
          </button>
        )
      })}
    </div>
  )
}
